export default "__VITE_ASSET__CFXz2osK__"